import { createRouter, createWebHistory } from 'vue-router'
import PageSignin from '../pages/PageSignin.vue'
import store from '../store/index.js'

const routes = [
    {
        path: '/distributor/signin',
        name: 'PageSignin',
        meta: { for_guest: true },
        component: PageSignin
    },
    {
        path: '/distributor/sso-login',
        name: 'PageSsoLogin',
        meta: { for_guest: true },
        component: () => import('../pages/PageSsoLogin.vue')
    },
    {
        path: '/distributor/',
        name: 'PageHome',
        component: () => import('../pages/PageHome.vue')
    },
    // お知らせ詳細
    {
        path: '/distributor/article/:id',
        name: 'PageArticle',
        component: () => import('../pages/PageArticle.vue')
    },
    {
        path: '/distributor/school',
        name: 'PageSchoolList',
        component: () => import('../pages/PageSchoolList.vue')
    },
    {
        path: '/distributor/school/:school_id/order',
        name: 'PageSchoolOrder',
        component: () => import('../pages/PageSchoolOrder.vue')
    },
    {
        path: '/distributor/order',
        name: 'PageOrderList',
        component: () => import('../pages/PageOrderList.vue')
    },
    {
        path: '/distributor/order/:id',
        name: 'PageOrderDetail',
        component: () => import('../pages/PageOrderDetail.vue')
    },
    /**
     * エラー系
     */
    {
        //404ページ ＝ 上記のいずれにもマッチしないもの
        path: '/distributor/:pathMatch(.*)*',
        name: 'Error404',
        component: () => import('../pages/PageError404.vue')
    },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => !record.meta.for_guest) && !store.state.distributor.auth.access_token) {
        next({ path: '/distributor/signin', query: { redirect: to.fullPath } });
    } else {
        next();
    }
});

export default router
